import { enumTradeAggregateType } from '@rematter/frontend-lib-api-client';

import {
  useTradeAggregateIdFilter,
  useTradeAggregateTypeFilter,
} from '@/audit-log/_state/tradeEvents.state';
import { useTranslations } from '@/audit-log/i18n/useTranslations';
import { SelectBooking } from '~/shared/components/select-fields/SelectBooking';
import { SelectLoad } from '~/shared/components/select-fields/SelectLoad';
import { SelectSalesOrder } from '~/shared/components/select-fields/SelectSalesOrder';

export const TradeEntityFilter = () => {
  const t = useTranslations();
  const [aggregateType] = useTradeAggregateTypeFilter();
  const [aggregateId, setAggregateId] = useTradeAggregateIdFilter();

  if (!aggregateType) return null;

  const handleChange = (id: string | undefined) => {
    setAggregateId(id);
  };

  switch (aggregateType) {
    case enumTradeAggregateType.Booking:
      return (
        <SelectBooking
          value={aggregateId}
          onChange={handleChange}
          placeholder={t.tradeEventsView.filter.selectBooking}
          clearable
        />
      );
    case enumTradeAggregateType.Load:
      return (
        <SelectLoad
          value={aggregateId}
          onChange={handleChange}
          placeholder={t.tradeEventsView.filter.selectLoad}
          clearable
        />
      );
    case enumTradeAggregateType.SalesOrder:
      return (
        <SelectSalesOrder
          value={aggregateId}
          onChange={handleChange}
          placeholder={t.tradeEventsView.filter.selectSalesOrder}
          clearable
        />
      );
    case enumTradeAggregateType.PurchaseOrder:
      return (
        <SelectSalesOrder
          value={aggregateId}
          onChange={handleChange}
          placeholder={t.tradeEventsView.filter.selectPurchaseOrder}
          clearable
        />
      );
    default:
      return null;
  }
};
